import React from 'react';
import { View } from 'react-native';
import { Pie, PieChart, ResponsiveContainer, Tooltip, Cell } from 'recharts';
import CloverConnectionStatuses from 'types/models/CloverConnectionStatuses';

const COLORS = ['#65da26ff', '#e91919ff'];

const renderCustomizedLabel = ({ name, value }) => {
  return `${name}: ${value}`;
};

export default function CloverConnectionPaperChart({ cloverPointStatuses, t }: { cloverPointStatuses: CloverConnectionStatuses, t: any }): JSX.Element {
  const data = React.useMemo(() => {
    const whitPaper = 
      cloverPointStatuses.offline + 
      cloverPointStatuses.unstable + 
      cloverPointStatuses.online - 
      cloverPointStatuses.whitoutPaper;
    return [
      { name: t('clover-connection-status.with-paper'), value: whitPaper },
      { name: t('clover-connection-status.without-paper'), value: cloverPointStatuses.whitoutPaper },
    ];
  }, [cloverPointStatuses]);
  return (
    <View style={{ width: '100%', height: 400 }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            cx="50%"
            cy="50%"
            innerRadius={70}
            outerRadius={90}
            labelLine={false}
            label={renderCustomizedLabel}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip
            formatter={(value, name) => [
              `${value}%)`,
              name,
            ]}
          />
        </PieChart>
      </ResponsiveContainer>
    </View>
  );
}
